export default __webpack_public_path__ + "static/client5-5474e7f2bd2044d9bb9b938d10c6df39.png";